import { Box, CircularProgress } from '@mui/material';

import {
  selectOnboardingActiveStep,
  useAppSelector,
  useFetchDesignationOptionsQuery,
  useFetchPlanQuery,
  useFetchUserProfileQuery,
} from '@/store';

import { StepComponents } from './steps';
import { MODAL_HEIGHT } from './styles';
import { useOnboardingSteps } from './useOnboardingSteps';

export const OnboardingForm = () => {
  const activeStep = useAppSelector(selectOnboardingActiveStep);
  const { steps } = useOnboardingSteps();

  const planQuery = useFetchPlanQuery(undefined, {
    refetchOnMountOrArgChange: true,
  });
  const designationOptionsQuery = useFetchDesignationOptionsQuery();
  const profileQuery = useFetchUserProfileQuery();

  const isLoading = [planQuery, designationOptionsQuery, profileQuery].some(
    q => q.isLoading,
  );

  const stepComponents = steps.map(id => ({
    id,
    Component: StepComponents[id],
  }));

  return (
    <Box
      sx={{
        width: { xs: '100%', md: MODAL_HEIGHT },
        height: { xs: '100vh', md: MODAL_HEIGHT },
        overflow: 'hidden',
        display: 'flex',
      }}>
      {isLoading ? (
        <Box
          sx={{
            flexGrow: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}>
          <CircularProgress />
        </Box>
      ) : (
        stepComponents.map(({ id, Component }) => (
          <Box
            key={id}
            sx={[
              {
                display: 'flex',
                width: '100%',
              },
              activeStep !== id && { display: 'none' },
            ]}>
            <Component />
          </Box>
        ))
      )}
    </Box>
  );
};
